<template>
  <div>
    <w-datepicker :model="schema.actionDataToPass.rangeStartDate" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz daty początku decyzji
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
